import React from 'react';
import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

export type SwitchProps = MuiSwitchProps;

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
  return <MuiSwitch color='primary' {...props} ref={ref} />;
});
